import {
    exchangeSession, getSessionKey, storedCredential, LOGIN_INFO_STORAGE, SESSION_KEY_STORAGE, VSPACE_CREDENTIAL_STORAGE
} from './common-rest/cryptoKeys'

// The mobile app opens MSP pages with its (legacy) credential in this query parameter.
export const MOBILE_PARAM = '?datamoblie='

// Runs before the app modules load (src/index.tsx): take over a mobile credential, then make sure this
// tab has the session key of the stored credential, so localStorage decrypts when Sidebar reads it.
export function prepareSession(win: { location: { search: string } }): Promise<void> {
    const search = win.location.search
    if (search.substring(0, MOBILE_PARAM.length) === MOBILE_PARAM) {
        let credential = ''
        try {
            credential = decodeURI(search.substring(MOBILE_PARAM.length))
        } catch (e) {
            // A malformed value is ignored: the existing session stays as it is.
        }
        if (credential) {
            localStorage.setItem(VSPACE_CREDENTIAL_STORAGE, credential)
            sessionStorage.removeItem(SESSION_KEY_STORAGE)
            // The previous user's login details must not outlive their credential.
            localStorage.removeItem(LOGIN_INFO_STORAGE)
        }
    }
    if (getSessionKey() || !storedCredential()) return Promise.resolve()
    const exchanged = storedCredential()
    // A failed exchange leaves the user signed out; the app still loads and shows the login page.
    return exchangeSession().catch(() => undefined).then(() => {
        // Another tab logged in during the exchange, so nothing was saved here: exchange its credential
        // once more. A plain failure is not retried (a 401 already cleared the session).
        const current = storedCredential()
        if (current && current !== exchanged && !getSessionKey()) return exchangeSession().catch(() => undefined)
    })
}
